/**
 * 32-bit string hash used as a save-integrity checksum.
 *
 * The output is PERSISTED alongside saved characters and compared on load, so the
 * algorithm must not change -- a different hash would invalidate every existing
 * save. This is a verbatim consolidation of three identical private copies in
 * LocalStorageService, MockGoogleDriveService and PersistenceService.
 *
 * Not a cryptographic hash; it only detects accidental corruption.
 */
export function calculateChecksum(data: string): string {
  let hash = 0;
  for (let i = 0; i < data.length; i++) {
    const char = data.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash; // Convert to 32-bit integer
  }
  return hash.toString(16);
}
